import React from "react";
import Lottie from "react-lottie";
import { thinkingSettings } from "../../views/calificacion/Styles";

export const Thinking = () => {
  return <Lottie options={thinkingSettings} width={400} />;
};
